import styled, { css } from "vue-styled-components";
import { lighten, darken } from "../../utils/colors";

export const AppAvatarProps = {
  variant: {
    type: String,
    default: "primary",
    validator: value => ["primary", "light"].includes(value)
  },
  size: {
    type: String,
    default: "md",
    validator: value => ["sm", "md", "lg", "xl"].includes(value)
  }
};

const variants = {
  primary: ({ colors }) => css`
    color: ${darken(colors.brand.primary, 10)};
    background-color: ${lighten(colors.brand.primary, 40)};
  `,
  light: ({ colors }) => css`
    color: ${colors.neutral.gray7};
    background-color: ${colors.neutral.gray1};
    border: 1px solid ${({ theme }) => theme.colors.neutral.gray2};
  `
};

const sizes = {
  sm: () => css`
    min-width: 42px;
    height: 42px;
    font-size: calc(42px - (42px * 70) / 100);
  `,
  md: () => css`
    min-width: 62px;
    height: 62px;
    font-size: calc(64px - (64px * 70) / 100);
  `,
  lg: () => css`
    min-width: 104px;
    height: 104px;
    font-size: calc(104px - (104px * 70) / 100);
  `,
  xl: () => css`
    min-width: 116px;
    height: 116px;
    font-size: calc(116px - (116px * 70) / 100);
  `
};

export const SWrapper = styled("div", AppAvatarProps)`
  ${({ variant, size, theme }) => css`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: center;
    text-align: center;
    border-radius: 50%;
    overflow: hidden;

    font-family: ${theme.font.family.inter};
    font-weight: ${theme.font.weight.semiBold};
    text-transform: uppercase;
    line-height: 150%;

    ${variant && variants[variant](theme)}
    ${size && sizes[size]}
  `}
`;

export const SPhoto = styled.figure`
  margin: 0;
  padding: 0;
  border-radius: 50%;
  height: 100%;
  width: 100%;

  img {
    height: 100%;
    width: 100%;
    border-radius: 50%;
    object-fit: cover;
    object-position: center;
    -o-object-fit: cover;
    -o-object-position: center;
  }
`;
